import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, ValueObject } from '@digibricks/core';
import moment from 'moment';
import { AssignmentType } from '../assignment-type';
import { UnixTimestamp } from '../unix-timestamp';
export var RemainTime = /*#__PURE__*/function (_ValueObject) {
  _inherits(RemainTime, _ValueObject);

  var _super = _createSuper(RemainTime);

  function RemainTime() {
    _classCallCheck(this, RemainTime);

    return _super.apply(this, arguments);
  }

  _createClass(RemainTime, [{
    key: "value",
    get: function get() {
      return this.props;
    }
  }], [{
    key: "create",
    value: function create(value) {
      if (value === null) {
        return Result.fail('Not have value');
      }

      var remainTime = new RemainTime(value);
      return Result.ok(remainTime);
    }
  }, {
    key: "createByRemainingAndEndTime",
    value: function createByRemainingAndEndTime(endTime, currentRemainTime) {
      var actualEndTime = UnixTimestamp.isInSecondType(endTime.toString()) ? moment.unix(Number(endTime)) : moment.unix(Number(endTime) / 1000);
      var currentTime = moment().valueOf() / 1000;
      var estimateEndTime = moment.unix(currentTime).add(currentRemainTime, 'second');
      var diffActualAndEstimate = actualEndTime.diff(estimateEndTime, 'second');

      if (diffActualAndEstimate > 0) {
        return this.create(currentRemainTime);
      }

      var newRemainTime = actualEndTime.diff(moment.unix(currentTime), 'second');
      return this.create(newRemainTime);
    }
  }, {
    key: "calculateEstimateEndTimeAndDiff",
    value: function calculateEstimateEndTimeAndDiff(startTime, duration, endTime) {
      var assignmentStartTimeInSecond = UnixTimestamp.isInSecondType(startTime.toString()) ? Number(startTime) : Number(startTime) / 1000;
      var assignmentEndTimeInSecond = UnixTimestamp.isInSecondType(endTime.toString()) ? Number(endTime) : Number(endTime) / 1000;
      var estimateEndTime = moment.unix(assignmentStartTimeInSecond).add(duration * 60, 'second');
      var diffActualAndEstimate = moment(estimateEndTime).diff(moment.unix(Number(assignmentEndTimeInSecond)), 'second');
      return {
        estimateEndTime: estimateEndTime,
        diffActualAndEstimate: diffActualAndEstimate
      };
    }
  }]);

  return RemainTime;
}(ValueObject);

_defineProperty(RemainTime, "calculateRemainingTime", function (assignment, submissionCreatedAt, recordedElapsedTime) {
  if (assignment) {
    // Use duration with fallback to 30 minutes if not set
    var duration = assignment.duration || 30;
    var remainingTime = duration * 60 - recordedElapsedTime;

    switch (assignment.type.id) {
      case AssignmentType.Practice:
        if (assignment.endTime) {
          var _RemainTime$calculate = RemainTime.calculateEstimateEndTimeAndDiff(submissionCreatedAt, assignment.duration, assignment.endTime),
              estimateEndTime = _RemainTime$calculate.estimateEndTime,
              diffActualAndEstimate = _RemainTime$calculate.diffActualAndEstimate;

          var remainingTimeResponse = RemainTime.createByRemainingAndEndTime(diffActualAndEstimate < 0 ? moment(estimateEndTime).unix() : assignment.endTime, remainingTime).getValue();
          remainingTime = remainingTimeResponse.value;
        }

        break;

      case AssignmentType.Homework:
        {
          var assignmentEndTimeInSecond = UnixTimestamp.isInSecondType(assignment.endTime) ? Number(assignment.endTime) : Number(assignment.endTime) / 1000;
          var endTime = moment.unix(assignmentEndTimeInSecond);
          var currentTime = moment().unix();
          remainingTime = moment(endTime).diff(moment.unix(currentTime), 'seconds');
          break;
        }

      case AssignmentType.Examination:
      default:
        {
          // For examination, use duration-based countdown but respect end time limit
          var durationBasedRemainingTime = duration * 60 - recordedElapsedTime; // Check if start time + duration > end time, then use end time

          if (assignment.endTime) {
            var _assignmentEndTimeInSecond = UnixTimestamp.isInSecondType(assignment.endTime) ? Number(assignment.endTime) : Number(assignment.endTime) / 1000;

            var _endTime = moment.unix(_assignmentEndTimeInSecond);

            var _currentTime = moment().unix();

            var endTimeBasedRemainingTime = moment(_endTime).diff(moment.unix(_currentTime), 'seconds'); // Use the smaller of the two remaining times

            remainingTime = Math.min(durationBasedRemainingTime, endTimeBasedRemainingTime);
          } else {
            remainingTime = durationBasedRemainingTime;
          }

          break;
        }
    }

    return Math.max(remainingTime, 0);
  }

  return null;
});